module.exports = __webpack_public_path__ + "static/media/Organization_7.7e3e4291.svg";